import React, { Suspense, lazy } from "react";

const SliderInner = lazy(() => import("./SliderInner"));

/**
 * Lazy-loaded Slider – react-slick wird erst bei Bedarf geladen.
 * Spart ~10 KiB im initialen Bundle (Grid mit sliderOnMobile, Multimedia mit >1 Bild).
 */
const Slider = (props) => (
  <Suspense fallback={<div style={{ minHeight: 200 }} />}>
    <SliderInner {...props} />
  </Suspense>
);

export default Slider;
